import styles from "./NewNavigation.module.css"
import ThePageContent from "../../Shared/Components/UI/PageContentContainer/ThePageContent"
import { useResponsiveMediaStateHook } from "../../Hooks/responsive-hook";
import { useRoutingHook, useSearchHook, useLanguageHook, useRetailerHook } from "../../Hooks/use-context-hooks";
import LinkedLogo from "../../components/Logo/LinkedLogo";

import { SearchComponent } from "../../components/Search/SearchComponent/SearchComponent";
import { IconComponent } from "../../components/Icon/IconComponent";
import { AnimatePresence } from "framer-motion";
import Overlay from "../../components/Overlay/Overlay";
import { GridSystem } from "../../Shared/Components/GridSystem/GridSystem";
import { motion } from "framer-motion";
import { PageText } from "../../components/Text/Text";
import { AnimatedComponent } from "../../Hooks/use-framer-motion";
import NavigationLinks from "../../Shared/Components/UI/NavigationElements/NavigationLinks";
import NavigationLinkBox from "../../Shared/Components/UI/NavigationElements/NavigationLinkBox";
import { ExternalNavigationLinks } from "../../Shared/Components/UI/NavigationElements/ExternalNavigationLinks";
import TheButton from "../../Shared/Components/UI/TheButton/TheButton";
import NavListElements from "../../Shared/PurchasePro/Components/NavListElements/NavListElements";
import LanguageSelectionMenu from "../../Shared/Components/UI/LanguageSelectionMenu/LanguageSelectionMenu";
import { LinkComponent } from "../../components/Links/LinkComponent";
import { getStepUpChartLinks, getTransitionsChartLinks } from "../../config/use-resources-config";

// ANMIMATION
const linkVariants = {
    hidden: { opacity: 0, x: 100 },  // Start off-screen to the right
    visible: {
        opacity: 1,
        x: 0,  // Slide into view
        transition: {
            type: "spring",  // Use a spring-like motion
            stiffness: 150,   // Controls speed of the spring effect
            damping: 13,      // Smooths the spring stop
            // duration: 0.4     // Ensures a smooth animation time
        }
    },
    exit: {
        opacity: 0,
        x: 100,  // Slide out to the right when exiting
        transition: {
            ease: "easeInOut",
            // duration: 0.3     // Smooth exit duration
        }
    }
};

// Opacity & Bounce (Spring) Effect
const navLinkVariants = {
    hidden: { opacity: 0, y: -20 },
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            type: "spring",  // Use a spring-like motion
            stiffness: 150,   // How fast the spring will react
            damping: 14,      // How bouncy the motion is
            // duration: 0.5     // Total duration
            // ease: [0.68, -0.55, 0.27, 1.55]  // Bouncy ease for playful motion
        }
    },
    exit: {
        opacity: 0,
        y: -20,
        transition:
        {
            // duration: 0.2, 
            ease: "easeInOut"
        }
    }
};



const MobileNav = () => {

    const { isMediumScreen } = useResponsiveMediaStateHook();
    const { setIsRoutingState, isRoutingState, isNavLinkClicked } = useRoutingHook();
    const { isHomeDepotApp } = useRetailerHook();
    const { setIsMobileSearchState } = useSearchHook();
    const { translatedText, language } = useLanguageHook();

    const stepUpLinks = getStepUpChartLinks(language, isHomeDepotApp.isHomeDepotActive, translatedText);
    const transitionsLinks = getTransitionsChartLinks(language, isHomeDepotApp.isHomeDepotActive, translatedText);

    const translatedHubLinkLG = language === "EN" ? 'https://lgplus.ca/home-appliance-en/' : 'https://lgplus.ca/fr/electromenager/'
    const translatedHubLinkHD = language === "EN" ? 'https://lgretaillink.com/' : 'https://lgretaillink.com/home-depot-ha-fr/'

    const externalSiteHubs = {
        buttonText: isHomeDepotApp.isHomeDepotActive ? 'LG Retail Link' : 'LG Plus',
        buttonLink: isHomeDepotApp.isHomeDepotActive ? translatedHubLinkHD : translatedHubLinkLG
    }


    const handleLinkClick = () => {
        setIsRoutingState(prevState => ({
            ...prevState,
            isMobileNavOpen: false,
            isCategoriesMenuOpen: false,
            isResourcesMenuOpen: false,
            isAccountMenuOpen: false,
            isBuilderDropdownOpen: false,
            isMobileBuilderDropdownOpen: false,
            isExclusiveMenuOpen: false,
            isNavLinkClicked: true,
        }))
    }

    const handleToggleMainMobileMenu = () => {
        setIsRoutingState(prevState => (
            { ...prevState, isMobileNavOpen: !prevState.isMobileNavOpen }))
    }

    const handleToggleMobileAppliancesMenu = () => {
        setIsRoutingState(prevState => ({ ...prevState, isMobileCategoriesMenuOpen: !prevState.isMobileCategoriesMenuOpen }))
    }
    const handleToggleMobileResourcesMenu = () => {
        setIsRoutingState(prevState => ({ ...prevState, isMobileResourcesMenuOpen: !prevState.isMobileResourcesMenuOpen }))
    }
    const handleToggleMobileExclusiveMenu = () => {
        setIsRoutingState(prevState => ({ ...prevState, isMobileExclusiveMenuOpen: !prevState.isMobileExclusiveMenuOpen }))
    }

    const handleMobileSearchIconClick = () => {
        setIsMobileSearchState(prevState =>
            ({ ...prevState, isMobileSearch: true }))
    }
    // const handleToggleMobileAccountMenu = () => {
    //     setIsRoutingState(prevState => ({
    //         ...prevState,
    //         isMobileAccountMenuOpen: !prevState.isMobileAccountMenuOpen
    //     }))
    // }
    const dropdownMarginTop = isRoutingState.isWelcomeBarShowing ? '10rem' : '6.1rem'

    const appliancesLinkMap = [
        {
            href: `${isHomeDepotApp.isHomeDepotPrefix}/appliances/Laundry`,
            text: translatedText.laundry
        },
        {
            href: `${isHomeDepotApp.isHomeDepotPrefix}/appliances/Refrigeration`,
            text: translatedText.refrigeration
        },
        {
            href: `${isHomeDepotApp.isHomeDepotPrefix}/appliances/Cooking`,
            text: translatedText.cooking
        },
        {
            href: `${isHomeDepotApp.isHomeDepotPrefix}/appliances/Dishwasher`,
            text: translatedText.dishwasher
        },
        {
            href: `${isHomeDepotApp.isHomeDepotPrefix}/appliances/LG Studio`,
            text: "LG Studio"
        },
        {
            href: `${isHomeDepotApp.isHomeDepotPrefix}/appliances`,
            text: translatedText.viewAll
        }
    ];

    const resourcesLinkMap = [
        {
            href: `${isHomeDepotApp.isHomeDepotPrefix}/resources/definitions`,
            text: translatedText.featureDefinitions
        },
        {
            href: `${isHomeDepotApp.isHomeDepotPrefix}/resources/warranties`,
            text: translatedText.limitedWarranties
        },



    ];
    return (
        <div className={styles.mobileNavComponentContainer}>
            <div className={styles.mobileLogoWrapper}>
                <LinkedLogo />
            </div>
            <div className={styles.mobileIconsWrapper}>
                {
                    isMediumScreen
                        ?
                        <div className={styles.mobileMediumSearchConditionWrapper}>
                            <SearchComponent type="desktop" />
                        </div>
                        : <IconComponent onClick={handleMobileSearchIconClick} iconType='searchInput' />
                }
                <NavListElements />
                <IconComponent
                    onClick={handleToggleMainMobileMenu}
                    iconType={isRoutingState.isMobileNavOpen === true ? 'xClose' : 'mobileNavMenu'} />
            </div>
            <AnimatePresence>
                {isRoutingState.isMobileNavOpen &&

                    <Overlay
                        // containerMarginTop={isMediumScreen ? "8.85rem" : "7.3rem"}
                        // containerMarginTop={isMediumScreen ? "6rem" : "6rem"}
                        containerMarginTop={dropdownMarginTop}
                        slideDirection="right">
                        <GridSystem>
                            <div className={styles.mobileNavDropdownMenuWrapper}>
                                <motion.div variants={linkVariants} initial="hidden" animate="visible" exit="exit" className={styles.mobileMenuBackIconWrapper}>
                                    <span className={styles.hoverableText}>
                                        <IconComponent onClick={handleToggleMainMobileMenu} iconType='leftChevron' />
                                    </span>
                                </motion.div>
                                <div id={styles.firstHeader} className={styles.mobileMenuHeader} >

                                    <motion.div
                                        variants={linkVariants}
                                        initial="hidden"
                                        animate="visible"
                                        exit="exit"
                                        onClick={handleToggleMobileAppliancesMenu}
                                        className={styles.headerText}
                                    >
                                        <span className={styles.hoverableText}>
                                            <PageText type='mobileNavTitle'>{translatedText.homeAppliances}</PageText>
                                        </span>
                                        <span className={styles.hoverableText}>
                                            <IconComponent iconType='rightChevron' />
                                        </span>
                                    </motion.div>
                                </div>

                                <div className={styles.mobileMenuHeader} >
                                    <motion.div variants={linkVariants} onClick={handleToggleMobileResourcesMenu} className={styles.headerText}>
                                        <span className={styles.hoverableText}><PageText type='mobileNavTitle'>{translatedText.resources}</PageText></span>
                                        <span className={styles.hoverableText}> <IconComponent iconType='rightChevron' /></span>
                                    </motion.div>
                                </div>
                                <div className={styles.mobileMenuHeader} >
                                    <motion.div variants={linkVariants} onClick={handleToggleMobileExclusiveMenu} className={styles.headerText}>
                                        {/* <PageText type='mobileNavTitle'>Exclusive</PageText> */}
                                        <span className={styles.hoverableText}> <PageText type='mobileNavTitle'>{translatedText.exclusiveOffers}</PageText></span>
                                        <span className={styles.hoverableText}> <IconComponent iconType='rightChevron' /></span>
                                    </motion.div>
                                </div>
                                <div className={styles.mobileMenuHeader} >
                                    <motion.div variants={linkVariants} className={styles.headerText}>
                                        <a
                                            href={externalSiteHubs.buttonLink}
                                            target="_blank" rel="noopener noreferrer"
                                        >
                                            <button className={styles.lgPlusButton}>{externalSiteHubs.buttonText}</button>
                                        </a>
                                    </motion.div>
                                </div>
                                <div className={styles.mobileMenuHeader} >
                                    <motion.div variants={linkVariants} className={styles.headerText}>

                                        <section className={styles.desktopLanguageSelectionBox}>
                                            <LanguageSelectionMenu />
                                        </section>

                                    </motion.div>
                                </div>
                            </div>

                        </GridSystem>
                    </Overlay>
                }
            </AnimatePresence>
            <AnimatePresence>
                {
                    isRoutingState.isMobileCategoriesMenuOpen &&
                    <Overlay
                        containerMarginTop={dropdownMarginTop}
                    >
                        <GridSystem>
                            <div className={styles.mobileNavDropdownMenuWrapper}>
                                <div className={styles.mobileMenuBackIconWrapper}>
                                    <span className={styles.hoverableText}>
                                        <IconComponent onClick={handleToggleMobileAppliancesMenu} iconType='leftChevron' />
                                    </span>
                                </div>

                                <div className={styles.mobileDropdownContent}>
                                    <ul className={styles.mobileNavOptionsList}>
                                        {appliancesLinkMap && appliancesLinkMap.map((e, idx) =>
                                            <motion.li
                                                key={idx}
                                                variants={navLinkVariants}  // Apply the staggered animation variants
                                                initial="hidden"         // Initial state for each list item
                                                animate="visible"        // Animate to visible when the dropdown is open
                                                exit="exit"
                                            >
                                                <NavigationLinks
                                                    styleName="menuLinks"
                                                    className={({ isActive }) => isActive ? styles.active : undefined}
                                                    linkText={e.text}
                                                    to={e.href}
                                                    onClick={handleLinkClick}
                                                />
                                            </motion.li>

                                        )}

                                    </ul>

                                </div>
                            </div>
                        </GridSystem>
                    </Overlay>
                }
            </AnimatePresence>
            <AnimatePresence>
                {
                    isRoutingState.isMobileResourcesMenuOpen &&
                    <Overlay
                        containerMarginTop={dropdownMarginTop}
                    >
                        <GridSystem>
                            <div className={styles.mobileNavDropdownMenuWrapper}>
                                <div className={styles.mobileMenuBackIconWrapper}>
                                    <span className={styles.hoverableText}>
                                        <IconComponent onClick={handleToggleMobileResourcesMenu} iconType='leftChevron' />
                                    </span>
                                </div>

                                <div className={styles.mobileDropdownContent}>
                                    {/* <ul className={styles.mobileNavOptionsList}>
                                        {transitionsLinks && transitionsLinks.map((e, idx) =>
                                            <motion.li
                                                key={idx}
                                                variants={navLinkVariants}
                                                initial="hidden"
                                                animate="visible"
                                                exit="exit"
                                            >
                                                <NavigationLinks
                                                    styleName="menuLinks"
                                                    className={({ isActive }) => isActive ? styles.active : undefined}
                                                    linkText={e.text}
                                                    to={e.href}
                                                    onClick={handleLinkClick}
                                                />
                                            </motion.li>
                                        )}

                                    </ul> */}
                                    <ul className={styles.mobileNavOptionsList}>
                                     
                                        {resourcesLinkMap && resourcesLinkMap.map((e, idx) =>
                                            <motion.li
                                                key={idx}
                                                variants={navLinkVariants}
                                                initial="hidden"      
                                                animate="visible"
                                                exit="exit"
                                            >
                                                <NavigationLinks
                                                    styleName="menuLinks"
                                                    className={({ isActive }) => isActive ? styles.active : undefined}
                                                    linkText={e.text}
                                                    to={e.href}
                                                    onClick={handleLinkClick}
                                                />
                                            </motion.li>
                                        )}
                                           {
                                            transitionsLinks && transitionsLinks.map((e, idx) => {
                                                const linkText = e.text;
                                                console.log(linkText)
                                                return (
                                                    <motion.li
                                                        key={idx}
                                                        variants={navLinkVariants}
                                                        initial="hidden"         //
                                                        animate="visible"
                                                        exit="exit"
                                                    >
                                                        {/* {e.text} */}
                                                        <NavigationLinks
                                                            styleName="menuLinks"
                                                            className={({ isActive }) => isActive ? styles.active : undefined}
                                                            linkText={`${e.text}`}
                                                            to={e.link}
                                                        // to={e.href}
                                                        // onClick={handleLinkClick}
                                                        />

                                                    </motion.li>
                                                )
                                            })
                                        }
                                        {
                                            stepUpLinks && stepUpLinks.map((e, idx) => {
                                                const linkText = e.text;
                                                console.log(linkText)
                                                return (
                                                    <motion.li
                                                        key={idx}
                                                        variants={navLinkVariants}
                                                        initial="hidden"         //
                                                        animate="visible"
                                                        exit="exit"
                                                    >
                                                        {/* {e.text} */}
                                                        <NavigationLinks
                                                            styleName="menuLinks"
                                                            className={({ isActive }) => isActive ? styles.active : undefined}
                                                            linkText={`${e.text} ${translatedText.stepUpChart}`}
                                                            to={e.link}
                                                        // to={e.href}
                                                        // onClick={handleLinkClick}
                                                        />
                                                        <NavigationLinks
                                                            styleName="menuLinks"
                                                            className={({ isActive }) => isActive ? styles.active : undefined}
                                                            linkText={`${e.text}  `}
                                                            to={e.href}
                                                            onClick={handleLinkClick}
                                                        />
                                                        <NavigationLinks
                                                            styleName="menuLinks"
                                                            className={({ isActive }) => isActive ? styles.active : undefined}
                                                            linkText={e.text}
                                                            to={e.href}
                                                            onClick={handleLinkClick}
                                                        />
                                                    </motion.li>
                                                )
                                            })
                                        }


                                    </ul>



                                </div>
                            </div>
                        </GridSystem>
                    </Overlay>
                }
            </AnimatePresence>
            <AnimatePresence>
                {
                    isRoutingState.isMobileExclusiveMenuOpen &&
                    <Overlay
                        containerMarginTop={dropdownMarginTop}
                    >
                        <GridSystem>
                            <div className={styles.mobileNavDropdownMenuWrapper}>
                                <div className={styles.mobileMenuBackIconWrapper}>
                                    <span className={styles.hoverableText}>
                                        <IconComponent onClick={handleToggleMobileExclusiveMenu} iconType='leftChevron' />
                                    </span>
                                </div>

                                <div className={styles.mobileDropdownContent}>
                                    <ul className={styles.mobileNavOptionsList}>
                                        <motion.li
                                            onClick={handleLinkClick}
                                            variants={navLinkVariants}
                                            initial="hidden"
                                            animate="visible"
                                            exit="exit"
                                        >
                                            <NavigationLinks
                                                styleName="menuLinks"
                                                className={({ isActive }) => isActive ? styles.active : undefined}
                                                linkText={translatedText.pL}
                                                to={`${isHomeDepotApp.isHomeDepotPrefix}/product-list`}
                                            // onClick={handleLinkClick}
                                            />
                                        </motion.li>
                                    </ul>



                                </div>
                            </div>
                        </GridSystem>
                    </Overlay>
                }
            </AnimatePresence>

        </div>
    )
}



const DesktopNav = () => {

    const { setIsRoutingState, isRoutingState } = useRoutingHook();

    const { isHomeDepotApp } = useRetailerHook();
    const { setIsMobileSearchState } = useSearchHook();
    const { translatedText, language } = useLanguageHook();
    // HUB LINK LOGIC
    const translatedHubLinkLG = language === "EN" ? 'https://lgplus.ca/home-appliance-en/' : 'https://lgplus.ca/fr/electromenager/'
    const translatedHubLinkHD = language === "EN" ? 'https://lgretaillink.com/' : 'https://lgretaillink.com/home-depot-ha-fr/'

    const externalSiteHubs = {
        buttonText: isHomeDepotApp.isHomeDepotActive ? 'LG Retail Link' : 'LG Plus',
        buttonLink: isHomeDepotApp.isHomeDepotActive ? translatedHubLinkHD : translatedHubLinkLG
    }

    const stepUpLinks = getStepUpChartLinks(language, isHomeDepotApp.isHomeDepotActive, translatedText);
    const transitionsLinks = getTransitionsChartLinks(language, isHomeDepotApp.isHomeDepotActive, translatedText);


    const stepUpChartLinkMapLG = [

        // COOKING
        {
            link: language && language === 'EN'
                ? "https://ha-product-guide.s3.us-east-2.amazonaws.com/Product+Guide+Files/Step-Up+Charts/English/LG+Cooking+Step+Up+Chart+En.pdf"
                : "https://ha-product-guide.s3.us-east-2.amazonaws.com/Product+Guide+Files/Step-Up+Charts/French/LG+Cooking+Step+Up+Chart+Fr.pdf"
            ,
            text: `${translatedText.cooking} ${translatedText.stepUpChart}`
        },
        // LAUNDRY
        {
            link: language && language === 'EN'
                ? "https://ha-product-guide.s3.us-east-2.amazonaws.com/Product+Guide+Files/Step-Up+Charts/English/LG+Laundry+Step+Up+Chart.pdf"
                : "https://ha-product-guide.s3.us-east-2.amazonaws.com/Product+Guide+Files/Step-Up+Charts/French/LG+Laundry+Step+Up+Chart+Fr.pdf"
            ,
            text: `${translatedText.laundry} ${translatedText.stepUpChart}`
        },
        // DISHWASHER
        {
            link: language && language === 'EN'
                ? "https://ha-product-guide.s3.us-east-2.amazonaws.com/Product+Guide+Files/Step-Up+Charts/English/LG+Dish+Step+Up+Chart+En.pdf"
                : "https://ha-product-guide.s3.us-east-2.amazonaws.com/Product+Guide+Files/Step-Up+Charts/French/LG+Dish+Step+Up+Chart+Fr.pdf"
            ,
            text: `${translatedText.dishwasher} ${translatedText.stepUpChart}`

        },
        // FRIDGE
        {
            link: language && language === 'EN'
                ? "https://ha-product-guide.s3.us-east-2.amazonaws.com/Product+Guide+Files/Step-Up+Charts/English/LG+Fridge+Step+Up+Chart+En.pdf"
                : "https://ha-product-guide.s3.us-east-2.amazonaws.com/Product+Guide+Files/Step-Up+Charts/French/LG+Fridge+Step+Up+Chart+Fr.pdf"
            ,
            text: `${translatedText.refrigeration} ${translatedText.stepUpChart}`
        }
    ]

    const stepUpChartLinkMapHD = [

        // COOKING
        {
            link: language && language === 'EN'
                ? "https://ha-product-guide.s3.us-east-2.amazonaws.com/Product+Guide+Files/Retail+Link/Step+Up+Charts/English/LG+Cooking+Step+Up+Chart+HD+En.pdf"
                : "https://ha-product-guide.s3.us-east-2.amazonaws.com/Product+Guide+Files/Retail+Link/Step+Up+Charts/French/LG+Cooking+Step+Up+Chart+HD+Fr.pdf"
            ,
            text: `${translatedText.cooking} ${translatedText.stepUpChart}`
        },
        // LAUNDRY
        {
            link: language && language === 'EN'
                ? "https://ha-product-guide.s3.us-east-2.amazonaws.com/Product+Guide+Files/Retail+Link/Step+Up+Charts/English/LG+HD+Laundry+Step+Up+Chart+En.pdf"
                : "https://ha-product-guide.s3.us-east-2.amazonaws.com/Product+Guide+Files/Retail+Link/Step+Up+Charts/French/LG+HD+Laundry+Step+Up+Chart+Fr.pdf"
            ,
            text: `${translatedText.laundry} ${translatedText.stepUpChart}`
        },
        // DISHWASHER
        {
            link: language && language === 'EN'
                ? "https://ha-product-guide.s3.us-east-2.amazonaws.com/Product+Guide+Files/Retail+Link/Step+Up+Charts/English/LG+HD+Dish+Step+Up+Chart+En.pdf"
                : "https://ha-product-guide.s3.us-east-2.amazonaws.com/Product+Guide+Files/Retail+Link/Step+Up+Charts/French/LG+HD+Dish+Step+Up+Chart+Fr.pdf"
            ,
            text: `${translatedText.dishwasher} ${translatedText.stepUpChart}`
        },
        // FRIDGE
        {
            link: language && language === 'EN'
                ? "https://ha-product-guide.s3.us-east-2.amazonaws.com/Product+Guide+Files/Retail+Link/Step+Up+Charts/English/LG+HD+Fridge+Step+Up+En.pdf"
                : "https://ha-product-guide.s3.us-east-2.amazonaws.com/Product+Guide+Files/Retail+Link/Step+Up+Charts/French/LG+HD+Fridge+Step+Up+Chart+Fr.pdf"
            ,
            text: `${translatedText.refrigeration} ${translatedText.stepUpChart}`
        }
    ]

    const renderRetailerStepUpChartLinks = isHomeDepotApp && isHomeDepotApp.isHomeDepotActive === true
        ? stepUpChartLinkMapHD
        : stepUpChartLinkMapLG;


    const transitionsChartLinkMapLG = [
        {
            link: language && language === 'EN'
                ? "https://ha-product-guide.s3.us-east-2.amazonaws.com/Product+Guide+Files/Model+Transitions/LG+Product+Transitions.pdf"
                : "https://ha-product-guide.s3.us-east-2.amazonaws.com/Product+Guide+Files/Model+Transitions/LG+Product+Transitions+Fr.pdf"
            ,
            text: translatedText.cooking
        },
    ]
    const transitionsChartLinkMapHD = [
        {
            link: language && language === 'EN'
                ? "https://ha-product-guide.s3.us-east-2.amazonaws.com/Product+Guide+Files/Retail+Link/Model+Transitions/HD+LG+Product+Transitions.pdf"
                : "https://ha-product-guide.s3.us-east-2.amazonaws.com/Product+Guide+Files/Retail+Link/Model+Transitions/HD+LG+Product+Transitions+Fr.pdf"
            ,
            text: translatedText.cooking
        },
    ]
    const renderRetailerTransitionChartLinks = isHomeDepotApp && isHomeDepotApp.isHomeDepotActive === true
        ? transitionsChartLinkMapHD
        : transitionsChartLinkMapLG;


    const handleLinkClick = () => {
        setIsRoutingState(prevState => ({
            ...prevState,
            isMobileNavOpen: false,
            isCategoriesMenuOpen: false,
            isResourcesMenuOpen: false,
            isAccountMenuOpen: false,
            isBuilderDropdownOpen: false,
            isMobileBuilderDropdownOpen: false,
            isNavLinkClicked: true,
        }))
    }

    const handleAppliancesLinkMouseEnter = () => {
        setIsRoutingState(prevState => ({
            ...prevState,
            isCategoriesMenuOpen: true,
            isResourcesMenuOpen: false,
            isStepUpChartsMenuOpen: false,
            isExclusiveMenuOpen: false
        }));
    }
    const handleAppliancesLinkMouseLeave = () => {
        setIsRoutingState(prevState => ({
            ...prevState,
            isCategoriesMenuOpen: false
        }));
    }
    const handleResourcesLinkMouseEnter = () => {
        setIsRoutingState(prevState => ({
            ...prevState,
            isResourcesMenuOpen: true,
            isStepUpChartsMenuOpen: false,
            isCategoriesMenuOpen: false,
            isExclusiveMenuOpen: false
        }));
    }
    const handleResourcesLinkMouseLeave = () => {
        setIsRoutingState(prevState => ({
            ...prevState,
            isResourcesMenuOpen: false
        }));
    }


    const handleExclusiveLinkMouseEnter = () => {
        setIsRoutingState(prevState => ({
            ...prevState,
            isExclusiveMenuOpen: true,
            isCategoriesMenuOpen: false,
            isResourcesMenuOpen: false,
            isStepUpChartsMenuOpen: false,
        }));
    }
    const handleExclusiveLinkMouseLeave = () => {
        setIsRoutingState(prevState => ({
            ...prevState,
            isExclusiveMenuOpen: false
        }));
    }


    return (
        <div className={styles.desktopNavComponentContainer}>
            <GridSystem gridType='spread'>
                <div className={styles.desktopNavContainer}

                >
                    <div className={styles.desktopNavLogoWrapper}>
                        <LinkedLogo />
                    </div>
                    {/* MENU ITEMS */}
                    <section className={styles.desktopNavMainMenuWrapper}>
                        {/* APPLIANCES - EXPLORE */}
                        <div className={styles.dropdownSection} onMouseLeave={handleAppliancesLinkMouseLeave}>
                            <div className={styles.desktopNavMenuHeader}>
                                <div onMouseEnter={handleAppliancesLinkMouseEnter} className={styles.desktopNavMenuText}>
                                    <PageText type='navTitleText'> {translatedText.explore}</PageText>
                                </div>
                            </div>
                            <AnimatePresence>
                                {
                                    isRoutingState.isCategoriesMenuOpen &&
                                    <AnimatedComponent type='3dRoationDropdownEffects'>
                                        <div onMouseLeave={handleAppliancesLinkMouseLeave} className={styles.dropdownContainer}>
                                            <div id={styles.applianceDropdownWrapperWidth} className={styles.dropdownWrapper}>
                                                <div className={styles.dropdownContent}>
                                                    <div className={styles.dropdownLinks}>
                                                        <ul className={styles.dropdownLinksList}>
                                                            <div className={styles.desktopNavLinkGroup}>
                                                                <NavigationLinkBox>
                                                                    <NavigationLinks
                                                                        className={({ isActive }) => isActive ? styles.active : undefined}
                                                                        linkText={translatedText.cooking}
                                                                        to={`${isHomeDepotApp.isHomeDepotPrefix}/appliances/Cooking`}
                                                                        onClick={handleLinkClick}
                                                                    />
                                                                </NavigationLinkBox>
                                                                <NavigationLinkBox>
                                                                    <NavigationLinks
                                                                        className={({ isActive }) => isActive ? styles.active : undefined}
                                                                        linkText={translatedText.laundry}
                                                                        to={`${isHomeDepotApp.isHomeDepotPrefix}/appliances/Laundry`}
                                                                        onClick={handleLinkClick}
                                                                    />
                                                                </NavigationLinkBox>
                                                                <NavigationLinkBox>
                                                                    <NavigationLinks
                                                                        className={({ isActive }) => isActive ? styles.active : undefined}
                                                                        linkText={translatedText.dishwasher}
                                                                        to={`${isHomeDepotApp.isHomeDepotPrefix}/appliances/Dishwasher`}
                                                                        onClick={handleLinkClick}
                                                                    />
                                                                </NavigationLinkBox>
                                                                <NavigationLinkBox>
                                                                    <NavigationLinks
                                                                        className={({ isActive }) => isActive ? styles.active : undefined}
                                                                        linkText={translatedText.refrigeration}
                                                                        to={`${isHomeDepotApp.isHomeDepotPrefix}/appliances/Refrigeration`}
                                                                        onClick={handleLinkClick}
                                                                    />
                                                                </NavigationLinkBox>
                                                            </div>
                                                        </ul>
                                                        <ul className={styles.dropdownLinksList}>
                                                            <div className={styles.desktopNavLinkGroup}>

                                                                <NavigationLinkBox>
                                                                    <NavigationLinks
                                                                        className={({ isActive }) => isActive ? styles.active : undefined}
                                                                        linkText="LG Studio"
                                                                        to={`${isHomeDepotApp.isHomeDepotPrefix}/appliances/LG Studio`}
                                                                        onClick={handleLinkClick}
                                                                    />
                                                                </NavigationLinkBox>
                                                            </div>
                                                        </ul>
                                                        <div className={styles.dropdownLinks}>
                                                            <ul className={styles.dropdownLinksList}>
                                                                <div className={styles.desktopNavLinkGroup}>



                                                                    <NavigationLinkBox>
                                                                        <NavigationLinks
                                                                            className={({ isActive }) => isActive ? styles.active : undefined}
                                                                            linkText={translatedText.viewAll}
                                                                            to={`${isHomeDepotApp.isHomeDepotPrefix}/appliances/`}
                                                                            onClick={handleLinkClick}
                                                                        />
                                                                    </NavigationLinkBox>
                                                                </div>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </AnimatedComponent>
                                }
                            </AnimatePresence>
                        </div>

                        {/* RESOURCES */}
                        <div className={styles.dropdownSection} onMouseLeave={handleResourcesLinkMouseLeave}>
                            <div className={styles.desktopNavMenuHeader}>
                                <div onMouseEnter={handleResourcesLinkMouseEnter} className={styles.desktopNavMenuText}>
                                    <PageText type='navTitleText'> {translatedText.resources}</PageText>
                                </div>
                            </div>
                            <AnimatePresence>
                                {isRoutingState.isResourcesMenuOpen &&
                                    <AnimatedComponent type='3dRoationDropdownEffects'>
                                        <div onMouseLeave={handleResourcesLinkMouseLeave} className={styles.dropdownContainer}>
                                            <div id={styles.resourcesDropdownWrapperWidth} className={styles.dropdownWrapper}>
                                                <div className={styles.dropdownContent}>
                                                    <div className={styles.dropdownLinks}>

                                                        {/* STEP UP */}
                                                        <ul className={styles.dropdownLinksList}>
                                                            <div className={styles.desktopNavLinkGroup}>


                                                                {
                                                                    renderRetailerStepUpChartLinks && renderRetailerStepUpChartLinks.map((e, idx) => (

                                                                        <NavigationLinkBox key={idx}>
                                                                            <ExternalNavigationLinks linkText={e.text} to={e.link} />
                                                                        </NavigationLinkBox>

                                                                    ))
                                                                }
                                                            </div>
                                                        </ul>


                                                        {/* WARRANTY TRAN*/}
                                                        <ul className={styles.dropdownLinksList}>
                                                            <div className={styles.desktopNavLinkGroup}>
                                                                <NavigationLinkBox>
                                                                    <NavigationLinks
                                                                        className={({ isActive }) => isActive ? styles.active : undefined}
                                                                        linkText={translatedText.featureDefinitions}
                                                                        to={`${isHomeDepotApp.isHomeDepotPrefix}/resources/definitions`}
                                                                        onClick={handleLinkClick}
                                                                    />
                                                                </NavigationLinkBox>
                                                                <NavigationLinkBox>
                                                                    <NavigationLinks
                                                                        className={({ isActive }) => isActive ? styles.active : undefined}
                                                                        linkText={translatedText.limitedWarranties}
                                                                        to={`${isHomeDepotApp.isHomeDepotPrefix}/resources/warranties`}
                                                                        onClick={handleLinkClick}
                                                                    />
                                                                </NavigationLinkBox>

                                                                {
                                                                    renderRetailerTransitionChartLinks && renderRetailerTransitionChartLinks.map((e, idx) => (
                                                                        <div className={styles.externalNavLink} key={idx}>
                                                                            <NavigationLinkBox>
                                                                                <ExternalNavigationLinks linkText={translatedText.modelTransitions} to={e.link} />
                                                                            </NavigationLinkBox>
                                                                        </div>
                                                                    ))
                                                                }
                                                            </div>
                                                        </ul>



                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </AnimatedComponent>
                                }
                            </AnimatePresence>
                        </div>
                        <div className={styles.dropdownSection} onMouseLeave={handleExclusiveLinkMouseLeave}>
                            <div className={styles.desktopNavMenuHeader}>
                                <div onMouseEnter={handleExclusiveLinkMouseEnter} className={styles.desktopNavMenuText}>
                                    <PageText type='navTitleText'> {translatedText.tools}</PageText>
                                </div>
                            </div>
                            <AnimatePresence>
                                {isRoutingState.isExclusiveMenuOpen &&
                                    <AnimatedComponent type='3dRoationDropdownEffects'>
                                        <div onMouseLeave={handleExclusiveLinkMouseLeave} className={styles.dropdownContainer}>
                                            <div id={styles.toolsDropdownWrapperWidth} className={styles.dropdownWrapper}>
                                                <div className={styles.dropdownContent}>
                                                    <div className={styles.dropdownLinks}>
                                                        <ul className={styles.dropdownLinksList}>
                                                            <div className={styles.desktopNavLinkGroup}>
                                                                <NavigationLinkBox>
                                                                    <NavigationLinks
                                                                        className={({ isActive }) => isActive ? styles.active : undefined}
                                                                        linkText={translatedText.pL}
                                                                        to={`${isHomeDepotApp.isHomeDepotPrefix}/product-list`}
                                                                        onClick={handleLinkClick}
                                                                    />
                                                                </NavigationLinkBox>
                                                            </div>
                                                        </ul>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </AnimatedComponent>
                                }
                            </AnimatePresence>
                        </div>

                        {/* <LinkComponent
                            type="navTitleText"
                            href={`${isHomeDepotApp.isHomeDepotPrefix}/product-list`}
                            trackedLink={true}
                        >
                            {translatedText.pL}
                        </LinkComponent> */}
                    </section>

                    <section className={styles.desktopNavSearchWrapper}>
                        <SearchComponent type="desktop" />
                    </section>
                    <section className={styles.desktopNavMenuWrapper}>

                        <div className={styles.desktopNavIconsWrapper}>
                            {/* <ProductListIcon /> */}
                            <NavListElements />
                        </div>



                        <section className={styles.desktopLanguageSelectionBox}>
                            <LanguageSelectionMenu />
                        </section>
                        <a
                            href={externalSiteHubs.buttonLink}
                            target="_blank" rel="noopener noreferrer"
                        >
                            <button className={styles.lgPlusButton}>{externalSiteHubs.buttonText}</button>

                        </a>
                    </section>
                </div>
            </GridSystem>

        </div>
    )

}


export const NewNavigation = () => {


    return (
        <>
            <nav className={styles.mainNavComponentContainer}>
                <div className={styles.desktopNavWrapper}>
                    <DesktopNav />
                </div>
                <div className={styles.mobileNavWrapper}>
                    <MobileNav />
                </div>
            </nav>
            <ThePageContent />
        </>
    )
}